<template>
  <div fluid>
    <!-- <div class="pt-1 d-flex">
      <v-text-field
        style="max-width: 250px"
        dense
        filled
        class="pl-0 mr-2"
        placeholder="search"
        solo
        flat
        color="cyan"
        :loading="pageLoading"
      />
    </div> -->
    <v-card
      flat
      class="custom-setting-height custom-grey-border remove-border-radius"
    >
      <v-card-title class="headline grey lighten-4">
        <v-row style="overflow: auto">
          <v-col md="12">
            <v-simple-table
              class="simple-table custom-table-height"
              fixed-header
              style="height: calc(67vh - 240px)"
            >
              <thead>
                <tr>
                  <th class="simple-table-th">Sno.</th>
                  <th class="simple-table-th">Billing As Done</th>
                  <th class="simple-table-th">Billing Type</th>
                  <th class="simple-table-th">Invoice No</th>
                  <th class="simple-table-th">Billing Date</th>
                  <th class="simple-table-th">Billing Day</th>
                  <th class="simple-table-th">Action</th>
                </tr>
              </thead>

              <tbody class="custom-border-bottom">
                <template v-if="scheduleArr?.length">
                  <tr
                    v-for="(row, index) in scheduleArr"
                    :key="index"
                    link
                    class="alternate-listing-row"
                  >
                    <td class="td">{{ index + 1 }}</td>
                    <td class="td"> 
                      <v-checkbox
                      color="cyan"
                      v-model="row.status"
                    ></v-checkbox>
                   </td>
                    <td class="td text-capitalize">
                      <v-chip label small color="blue" text-color="white">
                        {{ row.billing_type }}</v-chip
                      >
                    </td>
                
                    <td class="td" width="18%">
                      <div class="d-flex">
                        <v-text-field
                          dense
                          filled
                          class="pl-0"
                          placeholder="Invoice No"
                          v-model="row.barcode"
                          solo
                          flat
                          color="cyan"
                          :loading="pageLoading"
                        />
                        <v-icon
                          :loading="pageLoading"
                          color="red"
                          :disabled="!row.barcode ? true : false"
                          v-on:click="removeRow(index)"
                        >
                          mdi-delete</v-icon
                        >
                      </div>
                    </td>
                    <td class="td">
                       <div class="d-flex align-center">
                        <div>
                          <date-picker
                           v-if="poEditMode"
                            key="date"
                            id="date"
                            placeholder="Date"
                            v-model="row.date"
                          />
                          <template v-else>
                            <template v-if="row?.date"> {{ formatDate(row.date) }}</template>
                            <em v-else class="text-muted">no row</em>
                          </template>
                        </div>
                        <div class="d-flex align-center">
                          <template v-if="poEditMode">
                            <v-btn
                              class="ml-2"
                              @click="poEditMode = false"
                      
                              icon
                              depressed
                              small
                              color="red"
                            >
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </template>

                          <v-btn
                            v-else
                            class="ml-2"
                            @click="poEditMode = true"
                            icon
                            depressed
                            small
                            color="cyan"
                          >
                            <v-icon small>mdi-pencil</v-icon>
                          </v-btn>
                        </div>
                      </div>
                      <!-- {{ formatDate(row.date) }} --></td>
                    <td class="td">
                      <div class="d-flex">
                        {{ row.dayName }}
                      </div>
                    </td>
                    <td class="td">
                      <v-btn
                        :loading="pageLoading"
                        depressed
                        tile
                        color="cyan white--text"
                        v-on:click="saveInvoice(row)"
                      >
                        <v-icon size="18">mdi-pencil</v-icon> Update</v-btn
                      >
                      <v-btn
                         v-if="detail?.status == 2"
                         class="ml-2"
                        :loading="pageLoading"
                        depressed
                        tile
                        color="red darken-4 white--text"
                        style="width: 15px !important;"
                        v-on:click="deletePopup(row.id)"
                      >
                        <v-icon size="18">mdi-delete</v-icon></v-btn
                      >
                    </td>
                  </tr>
                </template>
                <tr v-else>
                  <td :colspan="6" class="py-4">
                    <p
                      class="m-0 row-not-found text-center font-weight-500 font-size-16"
                    >
                      <img
                        :src="$assetURL('media/error/empty.png')"
                        class="row-not-found-image"
                      />
                      Uhh... There are no billing at the moment.
                    </p>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-card-title>
    </v-card>
     <DeleteDialog :delete-dialog="deleteDialog">
        <template v-slot:title>Delete Confirmation</template>
        <template v-slot:text>
          <h3 class="font-weight-500 delete-text text-center">
            Are you sure you want to delete this?
          </h3>
        </template>
        <template v-slot:action>
          <v-btn
            :disabled="deleteLoading"
            class="mx-2 custom-grey-border custom-bold-button"
            v-on:click="deleteDialog = false"
            >No! Cancel</v-btn
          >
          <v-btn
            :disabled="deleteLoading"
            :loading="deleteLoading"
            color="red lighten-1 white--text"
            v-on:click="deleteConfirm()"
            class="mx-2 custom-grey-border custom-bold-button"
            >Yes! Delete</v-btn
          >
        </template>
      </DeleteDialog>
  </div>
</template>

<script>
import { QUERY, PATCH,DELETE } from "@/core/services/store/request.module";
import CommonMixin from "@/core/plugins/common-mixin";
import { BillingEventBus } from "@/core/lib/billing.invoice.lib.js";
import DeleteDialog from "@/view/pages/partials/Delete";
import DatePicker from "@/view/components/QDatePicker.vue";

export default {
  mixins: [CommonMixin],
  data() {
    return {
      pageLoading: false,
      scheduleArr: [],
      deleteDialog: false,
      deleteLoading: false,
      deleteId: 0,
      poEditMode : false
      
    };
  },
  props: {
    detail: {
      type: Object,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
  },
  methods: {
    deletePopup(id) {
      this.deleteId = id;
      this.deleteDialog = true;       
    },
    deleteConfirm() {
      if (!this.deleteId) {
        return false;
      }
      this.deleteLoading = true;

      this.$store
        .dispatch(DELETE, { url: `billing-delete/${this.detail?.id}/${this.deleteId}` })
        .then(() => {
          this.deleteDialog = false;
          this.getBillings(); 
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.deleteLoading = false;
        });
    },
    getBillings() {
      const _this = this;
      _this.pageLoading = true;
      _this.$store
        .dispatch(QUERY, {
          url: "billing-schedule-list",
          data: {
            related_id: this.detail?.id,
            type: this.type ? this.type : null,
          },
        })
        .then(({ data }) => {
          _this.scheduleArr = data;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    removeRow(index) {
      this.scheduleArr[index].barcode = null;
    },
    saveInvoice(data) {
      this.pageLoading = true;

      this.$store
        .dispatch(PATCH, {
          url: "billing-number/update/" + data.id,
          data: {
            invoice_number: data.barcode,
            date: data.date,
            status: this.lodash.toSafeInteger(data.status),
          },
        })
        .then(() => {
          this.poEditMode = false;
          this.getBillings();
        })
        .catch((error) => {
          this.logError(error);
          this.pageLoading = false;
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },
  },
  mounted() {
    this.getBillings();

    BillingEventBus.$on("update:extend", () => {
      this.getBillings();
    });
  },

  components: {
    DeleteDialog,
    DatePicker
  },
};
</script>
<style>
.td {
  font-size: 14px !important;
  font-weight: 500;
}
</style>
